export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZakazkaKorekceTempl';
export const NAME = 'ZakazkaKorekceTempl';
